import { Component, Input, OnInit, Output, EventEmitter } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { SessionContextService } from "projects/packcert-web/src/app/context/session-context.service";
import { SpinnerService, Message } from 'shared-components';
import { CultivosService } from '../../../services/cultivos.service';

@Component ({
    selector: 'app-cultivo-finca',
    templateUrl: './cultivo-finca.component.html'
})
export class CultivoFincaComponent implements OnInit {

    private readonly _DEFAULT_ITEMS_PER_PAGE = 10;

    public listaCultivosFinca;
    public editables;
    public new = false;
    public newEditModal = false;
    public deleteModal = false;
    public edicionModal = false;
    public newModalDesignacion = false;
    public cultivoDesignacion;
    public cultivoFincaId;
    public itemsPerPage = this._DEFAULT_ITEMS_PER_PAGE;
    public currentPage = 0; // La paginación en back empieza por 0
    public totalItems: number;
    public readonly visiblePages = 3;
    public toCloseSpinner = 0;

    public codigoGsv;
    public campanyaId;
    public denominacionId;
    public open;

    public pestanaActiva = new Array<number>();
    public dropdownInfo: number;
    public dropdownSection: number;
    public blockchainInfo: number;

    public orderBy: string;
    public firtstime = true;
    public idColumn;

    public filters;

    @Input() fincaId;
    @Input() filtersCultivo;
    @Input() desFinca;
    @Input() paisId;

    @Output() mensaje = new EventEmitter<string>();

    constructor(
        private readonly _translate: TranslateService,
        private readonly _spinnerService: SpinnerService,
        private readonly _cultivoService: CultivosService,
        private readonly _sessionContext: SessionContextService
    ) {}

    ngOnInit() {
        this.getCultivosFinca();
    }

    public get defaultLanguage() {
        return this._translate.getDefaultLang();
    }

    public get role() {
        return this._sessionContext.sessionUser.role;
    }

    public get claims() {
        return this._sessionContext.sessionUser.lsClaimTypes;
    }

    public pageChange(page) {
        this.currentPage = page - 1;
        this.getCultivosFinca();
    }

    public itemsPerPageChange(items) {
        this.currentPage = 0;
        this.itemsPerPage = items;
        this.getCultivosFinca();
    }

    public getCultivosFinca() {
        this._spinnerService.showSpinner();
        this.toCloseSpinner += 1;
        this.filters = {...this.filtersCultivo};
        this.filters.fincaId = this.fincaId;
        this.filters.cargaRegBlockchain = true;
        this._cultivoService.getCultivosYDesignacionesFincaByFilters(this.filters).toPromise().finally(() => {
            this.checkCloseSpinner();
        }).then((resp) => {
            this.listaCultivosFinca = resp.cultivosAccesibles;
        });
    }

    public create() {
       this.cultivoFincaId = null;
       this.newEditModal = true;
    }

    public update(cultivoFinca) {
        this.cultivoFincaId = cultivoFinca.id;
        this.newEditModal = true;
    }

    public delete() {
        this._spinnerService.showSpinner();
        this.toCloseSpinner += 1;
        this._cultivoService.deleteCultivoFinca(this.cultivoFincaId).toPromise().finally(() => {
            this.checkCloseSpinner();
        }).then(() => {
            this.close();
            this.pushMessage('global.success.itemDeleted');
            this.getCultivosFinca();
        });
    }

    public askDelete(cultivoFinca) {
        this.cultivoFincaId = cultivoFinca.id;
        this.deleteModal = true;
    }

    public close() {
        this.deleteModal = false;
        this.newEditModal = false;
        this.edicionModal = false;
    }

    public pushMessage(mensaje) {
        this.mensaje.emit(mensaje);
    }

    public refresh(value) {
        this.newEditModal = false;
        if (value) {
            this.reload();
        }
    }

    public refreshDesignacion(value) {
      this.newModalDesignacion = false;
        if (value) {
          this.reload();
        }
    }

    public reload() {
        this.getCultivosFinca();
    }

    public openTabs(i) {
        this.dropdownSection = this.dropdownSection === i ? -1 : i;
        this.pestanaActiva[i] = this.pestanaActiva[i] > 0 ? this.pestanaActiva[i] : 1;
        if (this.dropdownSection !== -1 && window.innerWidth <= 1199) {
            setTimeout(() => {
                document.querySelector('table')?.scrollIntoView({behavior: 'smooth', block: 'nearest', inline: 'start'});
            }, 50);
        }
    }

    public showCultivosProductor(i) {
        this.pestanaActiva[i] = 1;
    }

    public showCultivosParcela(i) {
        this.pestanaActiva[i] = 2;
    }

    public showCultivosMarca(i) {
        this.pestanaActiva[i] = 3;
    }

    public openAppEdicion(cultivo) {
        this.edicionModal = true;
        this.codigoGsv = cultivo.codigoGsv;
        this.campanyaId = cultivo.campanyaId;
        this.paisId = cultivo.paisIdCampanya;
        this.denominacionId = cultivo.denominacionIdCampanya;
        cultivo.tieneGeo ? this.open = 1 : this.open = 2;
    }

    public closeMap() {
        this.edicionModal = false;
        this.codigoGsv = null;
        this.campanyaId = null;
        this.open = null;
        this.reload();
    }

    private checkCloseSpinner() {
        this.toCloseSpinner -= 1;
        if (this.toCloseSpinner === 0) {
            this._spinnerService.hideSpinner();
        }
    }

    public toOrderBy(id: any) {
      this.idColumn = id;
      if (this.firtstime) {
          this.orderBy = 'desc';
          this.firtstime = false;
      } else {
          if (this.orderBy === 'desc') {
              this.orderBy = 'asc';
          } else if (this.orderBy === 'asc') {
              this.orderBy = 'desc';
          }
      }
    }

    public getIcon(id: any) {
      let iconClass = 'fa fa-sort';
      if (id === this.idColumn) {
          iconClass = this.orderBy === 'desc' ? 'fa fa-sort-down' : 'fa fa-sort-up';
      }
      return iconClass;
    }

    public designarCultivo(cultivoFinca) {
      this.newModalDesignacion = true;
      this.cultivoDesignacion = cultivoFinca;
    }

    public showMoreInfo(index) {
        this.blockchainInfo = this.blockchainInfo === index ? -1 : index;
    }

    public trackByCultivoFincaId(index: number, cultivoFinca: { id: number }): number {
        return cultivoFinca.id;
    }
}
